import white from './belts/belt-12.png';
import yellowStripe from './belts/belt-11.png';
import yellow from './belts/belt-10.png';
import greenStripe from './belts/belt-09.png';
import green from './belts/belt-08.png';
import blueStripe from './belts/belt-07.png';
import blue from './belts/belt-06.png';
import brownStripe from './belts/belt-05.png';
import brown from './belts/belt-04.png';
import redStripe from './belts/belt-03.png';
import red from './belts/belt-02.png';
import blackStripe from './belts/belt-01.png';

export const belts = [
    { 
        id: 12,
        name: 'White Belt',
        image: white,
        form: 'Kibon',
        kup: '12th Kup',
        korean: '기본(基本)',
        moves: 12,
        movesDef: 'representing the number of months in a year',
        largeDef: "White represents a seed underneath the winter snow. Just as the seed has the potential to develop and grow into a healthy plant, the new student has the potential for growth mentally, spiritually, and physically.",
        meaning: "Basic or Beginning",
        smallDef: "Principle building blocks for your training, both mental and physical.",
        month: "January",
    },
    { 
        id: 11,
        name: 'Yellow Stripe',
        image: yellowStripe,
        form: 'Kicho',
        kup: '11th Kup',
        korean: '기초(基礎)',
        moves: 24,
        movesDef: 'representing the number of hours in a day',
        largeDef: "Yellow represents the sun. It's the sun that melts the snow causing the seed to germinate.",
        meaning: "Foundation",
        smallDef: "A solid foundation on which to build and develop your martial arts potential.",
        month: "February",
    },
    { 
        id: 10,
        name: 'Yellow Belt',
        image: yellow,
        form: 'Kyuki Il Chang',
        korean: '격기일장 (擊氣一章)',
        kup: '10th Kup',
        moves: 30,
        movesDef: 'representing the number of days in a month',
        ready: "represents strength (the closed fist) and control (the open hand covering the fist)",
        largeDef: "Yellow represents the sun. It's the sun that melts the snow causing the seed to germinate.",
        meaning: "Spark Spirit",
        smallDef: "Kyuki-Do's ability to awaken the spiritual potential within each of us.",
        month: "March",

    },
    { 
        id: 9,
        name: 'Green Stripe',
        image: greenStripe,
        form: 'Kyuki Yee Chang',
        korean: '격기이장 (擊氣二章)',
        kup: '9th Kup',
        moves: 31,
        movesDef: 'representing the number of days in a month',
        ready: "represents strength (the closed fist) and control (the open hand covering the fist)",
        largeDef: "Green is the color of spring. In springtime grown and activity abound. Just like the lush and vibrant plant, the student experiences significant growth at this rank.",
        meaning: "Spark Mental",
        smallDef: "Kyuki-Do's ability to awaken the mental potential within each of us.",
        month: "April",
    },
    { 
        id: 8,
        name: 'Green Belt',
        image: green,
        form: 'Kyuki Sam Chang',
        korean: '격기삼장 (擊氣三章)',
        kup: '8th Kup',
        moves: 29,
        movesDef: 'representing the number of days in February, in a leap year',
        ready: "represents strength (the closed fist) and control (the open hand covering the fist)",
        largeDef: "Green is the color of spring. In springtime grown and activity abound. Just like the lush and vibrant plant, the student experiences significant growth at this rank.",
        meaning: "Spark Physical",
        smallDef: "Kyuki-Do's ability to awaken the physical potential within each of us.",
        month: "May",
    },
    { 
        id: 7,
        name: 'Blue Stripe',
        image: blueStripe,
        form: 'Guen Bon',
        korean: '근본(根本)',
        kup: '7th Kup',
        moves: 28,
        movesDef: 'representing the number of days in February',
        ready: "represents planting a tree",
        largeDef: "Blue represents the summer sky. Like a plant growing toward the sky, the students strive to reach their full potential.",
        meaning: "Roots",
        smallDef: "Representing the past experiences of those who have gone before us and given of themselves for our benefit.",
        month: "June",
    },
    { 
        id: 6,
        name: 'Blue Belt',
        image: blue,
        form: 'Chon Ji In Il Chang',
        korean: '천지인일장 (天地人一章)',
        kup: '6th Kup',
        moves: 33,
        movesDef: 'representing infinity',
        ready: "represents the sky",
        largeDef: "Blue represents the summer sky. Like a plant growing toward the sky, the students strive to reach their full potential.",
        meaning: "Sky",
        smallDef: "The limitless potential for the development and well-being of the individual.",
        month: "July",
    },
    { 
        id: 5,
        name: 'Brown Stripe',
        image: brownStripe,
        form: 'Chon Ji In Yee Chang',
        korean: '천지이장 (天地二章)',
        kup: '5th Kup',
        moves: 33,
        movesDef: 'representing infinity',
        ready: "represents the earth",
        largeDef: "Brown represents maturity, the mature plants turning to brown in the later part of summer. The student has started to develop and mature into a serious martial artist.",
        meaning: "Earth",
        smallDef: "Earth, which has served as the one constant for the development of humanity.",
        month: "August",
    },
    { 
        id: 4,
        name: 'Brown Belt',
        image: brown,
        form: 'Chon Ji In Sam Chang',
        korean: '천지삼장 (天地三章)',
        kup: '4th Kup',
        moves: 33,
        movesDef: 'representing infinity',
        ready: "represents people",
        largeDef: "Brown represents maturity, the mature plants turning to brown in the later part of summer. The student has started to develop and mature into a serious martial artist.",
        meaning: "People",
        smallDef: "Humankind, which fills the cosmos with hopes, dreams and the uniqueness within each person; which together with the earth and heaven makes up the universe in which we live.",
        month: "September",
    },
    { 
        id: 3,
        name: 'Red Stripe',
        image: redStripe,
        form: 'Man Nam',
        korean: '만남(萬南)',
        kup: '3rd Kup',
        moves: 52,
        movesDef: 'representing the number of weeks in a year',
        largeDef: "Just as the leaves turning red in the fall warn us to be prepared for the coming of winter, the red belt warns the student that they are coming to the end of their first cycle and to prepare for the start of their next cycle, which begins with a 1st degree black belt.",
        meaning: "Meet or Gather Together",
        smallDef: "Learning from contact, we are the sum total of all the experiences we have had, represented by the coming together of the practitioner and the Bo staff.",
        month: "October",
    },
    { 
        id: 2,
        name: 'Red Belt',
        image: red,
        form: 'Ka Chi',
        korean: '같이',
        kup: '2nd Kup',
        moves: 36,
        movesDef: 'representing the minimum number of months for a dedicated student to travel from white belt to black belt',
        ready: "represents two people walking side by side",
        largeDef: "Just as the leaves turning red in the fall warn us to be prepared for the coming of winter, the red belt warns the student that they are coming to the end of their first cycle and to prepare for the start of their next cycle, which begins with a 1st degree black belt.",
        meaning: "Go Together",
        smallDef: "Sharing the journey of life.",
        month: "November",
    },
    { 
        id: 1,
        name: 'Black Stripe',
        image: blackStripe,
        form: 'Sa Rang',
        korean: '사랑',
        kup: '1st Kup',
        moves: 33,
        movesDef: 'representing infinity',
        largeDef: "Black is the color of knowledge and proficiency. It represents the completion of an earlier cycle (colored belts) which now starts again from the beginning (black belt levels).",
        meaning: "Love",
        smallDef: "The willingness to sacrifice yourself for the benefit of someone or something in which you believe.",
        month: "December",
    },
    {
        id: 0,
        name: 'Black Belt',
        image: blackStripe,
        kup: '1st Dan',
        form: 'Kyuki-Do Nakbop Hyung',
        korean: '격기도낙법형 (擊氣道落法型)',
        moves: 12,
        meaning: "Form of Falling",
    }
];

export {belts as default};
// export { default as whiteBelt } from './belts/belt-12.png';